
























































































import { Component, Vue } from "vue-property-decorator";
import { TextBlockType } from "@/shared/core/constants";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import store from "@/shared/core/store";
import CtaButton from "../ctaButton/ctaButton.vue";
import HomeCarouselFrame from "./HomeCarouselFrame.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

@Component({
  components: { CtaButton, HomeCarouselFrame, VueSlickCarousel },
})
export default class HomeFeaturedTherapist extends Vue {
  people: any[] = [];
  activeIndex = 0;
  virtualIndex = 0;
  stageHeight = 0;
  stageSideGap = 0;
  stageSideOffset = 0;
  pendingIndex: number | null = null;

  get socialLinks() {
    const settings = store.state.settings || {};
    const links = [
      { href: settings.Facebook, icon: "fa-facebook" },
      { href: settings.Twitter, icon: "fa-twitter" },
      { href: settings.Instagram, icon: "fa-instagram" },
    ];
    return links.filter((link) => !!link.href);
  }

  get visiblePeople() {
    if (this.people.length === 0) return [];
    const hasVisibilityFlag = this.people.some((item) => {
      const flag =
        item?.showOnHome ??
        item?.showInHome ??
        item?.showOnHomepage ??
        item?.visible ??
        item?.active ??
        item?.isActive ??
        item?.enabled ??
        item?.isEnabled;
      return flag !== undefined;
    });
    if (!hasVisibilityFlag) return this.people;
    return this.people.filter((item) => {
      const flag =
        item?.showOnHome ??
        item?.showInHome ??
        item?.showOnHomepage ??
        item?.visible ??
        item?.active ??
        item?.isActive ??
        item?.enabled ??
        item?.isEnabled;
      return Boolean(flag);
    });
  }

  async mounted() {
    window.addEventListener("resize", this.onResize);
    let filter: any = {};
    filter["TextBlockType"] = {
      type: "equals",
      filter: TextBlockType.Teams,
      filterType: "enum",
    };
    const gridStatus = JSON.stringify({ filters: filter });

    const url = `${
      Settings.HostName
    }/api/cztextblocks/list?startRow=0&endRow=50&lookup=true&gridstatus=${encodeURIComponent(
      gridStatus
    )}`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting therapists");
      return;
    }
    const rowData = data.rowData || [];
    this.people = rowData;
    this.activeIndex = 0;
    this.virtualIndex = 0;
    this.pendingIndex = null;
    this.$emit("loaded", this.visiblePeople.length);
    this.$nextTick(() => {
      this.updateStageHeight();
      this.restartAutoplay();
    });
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }

  get stageStyle() {
    const style: any = {};
    if (this.stageHeight) {
      style.minHeight = `${this.stageHeight}px`;
    }
    if (this.stageSideGap) {
      style["--home-therapist-side-gap"] = `${this.stageSideGap}px`;
    }
    if (this.stageSideOffset) {
      style["--home-therapist-side-offset"] = `${this.stageSideOffset}px`;
    }
    if (Object.keys(style).length === 0) {
      return undefined;
    }
    return style;
  }

  get visibleOffsets() {
    const total = this.visiblePeople.length;
    if (total === 0) return [];
    if (total === 1) return [0];
    if (total === 2) return [0];
    const offsets = [0];
    if (this.showSideCards) {
      offsets.unshift(-1);
      offsets.push(1);
    }
    if (this.showSmallCards) {
      offsets.unshift(-2);
      offsets.push(2);
    }
    return offsets;
  }

  get isDouble() {
    return false;
  }

  get showSideCards() {
    return this.visiblePeople.length > 2;
  }

  get showSmallCards() {
    return this.visiblePeople.length > 4;
  }

  get visibleSlides() {
    const total = this.visiblePeople.length;
    if (total === 0) return [];
    return this.visibleOffsets.map((offset) => {
      const index = (this.activeIndex + offset + total) % total;
      const person = this.visiblePeople[index] || this.visiblePeople[0];
      return {
        offset,
        index,
        person,
        key: String(this.virtualIndex + offset),
      };
    });
  }

  get shouldAutoplay() {
    return this.visiblePeople.length > 2;
  }

  get carouselSettings() {
    const shouldLoop = this.visiblePeople.length > 1;
    const shouldAutoplay = this.shouldAutoplay;
    return {
      arrows: false,
      dots: false,
      infinite: shouldLoop,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: shouldAutoplay,
      speed: 0,
      autoplaySpeed: 5000,
      cssEase: "ease-in-out",
      pauseOnHover: false,
      pauseOnFocus: false,
    };
  }

  onAfterChange(current: any) {
    const total = this.visiblePeople.length;
    if (total === 0) return;
    if (typeof current === "number") {
      if (this.pendingIndex !== null && current === this.pendingIndex) {
        this.pendingIndex = null;
        this.$nextTick(() => {
          this.updateStageHeight();
        });
        return;
      }
      if (this.pendingIndex !== null) {
        this.pendingIndex = null;
      }
      const previousIndex = this.activeIndex;
      this.activeIndex = current;
      this.virtualIndex += this.getNormalizedDelta(
        current,
        previousIndex,
        total
      );
      this.$nextTick(() => {
        this.updateStageHeight();
      });
      return;
    }
    if (current && typeof current.currentSlide === "number") {
      if (
        this.pendingIndex !== null &&
        current.currentSlide === this.pendingIndex
      ) {
        this.pendingIndex = null;
        this.$nextTick(() => {
          this.updateStageHeight();
        });
        return;
      }
      if (this.pendingIndex !== null) {
        this.pendingIndex = null;
      }
      const previousIndex = this.activeIndex;
      this.activeIndex = current.currentSlide;
      this.virtualIndex += this.getNormalizedDelta(
        current.currentSlide,
        previousIndex,
        total
      );
      this.$nextTick(() => {
        this.updateStageHeight();
      });
    }
  }

  setActiveOffset(offset: number) {
    if (this.visiblePeople.length === 0) return;
    const total = this.visiblePeople.length;
    const nextIndex = (this.activeIndex + offset + total) % total;
    this.setActiveIndex(nextIndex);
  }

  setActiveIndex(index: number) {
    if (this.visiblePeople.length === 0) return;
    const total = this.visiblePeople.length;
    const previousIndex = this.activeIndex;
    const nextIndex = ((index % total) + total) % total;
    this.activeIndex = nextIndex;
    this.virtualIndex += this.getNormalizedDelta(
      nextIndex,
      previousIndex,
      total
    );
    this.pendingIndex = nextIndex;
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.goTo) {
      carousel.goTo(nextIndex);
    }
    this.restartAutoplay();
    this.$nextTick(() => {
      this.updateStageHeight();
    });
  }

  restartAutoplay() {
    if (!this.shouldAutoplay) return;
    const carousel = this.$refs.carousel as any;
    if (!carousel) return;
    if (carousel.pause) {
      carousel.pause();
    } else if (carousel.slickPause) {
      carousel.slickPause();
    }
    if (carousel.play) {
      carousel.play();
      return;
    }
    if (carousel.slickPlay) {
      carousel.slickPlay();
    }
  }

  updateStageHeight() {
    const stage = this.$refs.stage as HTMLElement;
    if (!stage) return;
    const card = stage.querySelector(
      ".homeTherapist__card--center"
    ) as HTMLElement;
    if (!card) return;
    const nextHeight = card.offsetHeight;
    if (nextHeight && nextHeight !== this.stageHeight) {
      this.stageHeight = nextHeight;
    }
    if (typeof window === "undefined") return;
    if (window.innerWidth < 768) {
      if (this.stageSideGap !== 0) {
        this.stageSideGap = 0;
      }
      if (this.stageSideOffset !== 0) {
        this.stageSideOffset = 0;
      }
      return;
    }
    const stageRect = stage.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    const styles = window.getComputedStyle(stage);
    const paddingLeft = parseFloat(styles.paddingLeft) || 0;
    const paddingRight = parseFloat(styles.paddingRight) || 0;
    const availableWidth = stageRect.width - paddingLeft - paddingRight;
    const sideScale =
      parseFloat(styles.getPropertyValue("--home-therapist-side-scale")) || 1;
    const computedGap =
      (availableWidth - cardRect.width - cardRect.width * sideScale * 2) / 2;
    const nextGap = Math.max(18, Math.round(computedGap));
    if (nextGap !== this.stageSideGap) {
      this.stageSideGap = nextGap;
    }
    const nextOffset = Math.round(
      cardRect.width / 2 + (cardRect.width * sideScale) / 2 + nextGap
    );
    if (nextOffset !== this.stageSideOffset) {
      this.stageSideOffset = nextOffset;
    }
  }

  onResize() {
    this.updateStageHeight();
  }

  getImagePath(img: string) {
    if (!img) {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }

  getPlainText(html: string) {
    if (html === undefined || html === null || html === "") return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").trim();
  }

  getRole(item: any) {
    const role = (item && (item.category || item.Category)) || "";
    const roleText = this.getPlainText(String(role));
    const titleText = this.getPlainText(
      String((item && (item.title || item.Title)) || "")
    );
    if (!roleText || roleText === titleText) return "";
    return roleText;
  }

  getSlideKey(item: any, index: number) {
    return item?.id || item?.ID || item?.Id || item?.textBlockId || index;
  }

  getNormalizedDelta(nextIndex: number, currentIndex: number, total: number) {
    if (total <= 0) return 0;
    const raw = nextIndex - currentIndex;
    const forward = (raw + total) % total;
    const backward = forward - total;
    return Math.abs(backward) < Math.abs(forward) ? backward : forward;
  }

  cardClass(offset: number) {
    if (offset === 0) return "homeTherapist__card--center";
    if (offset === -1) return "homeTherapist__card--left";
    if (offset === 1) return "homeTherapist__card--right";
    if (offset === -2) return "homeTherapist__card--leftSm";
    if (offset === 2) return "homeTherapist__card--rightSm";
    if (offset < 0) return "homeTherapist__card--left";
    return "homeTherapist__card--right";
  }

  nextSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
    this.restartAutoplay();
  }

  prevSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
    this.restartAutoplay();
  }
}
